<template>
    <div class="box">
        <div class="box-content">
            <form method="POST" :action="'/registration-request/approve'" id="approve_new_user_form">
                <input type="hidden" :value="csrfToken" name="_token">
                <input type="hidden" name="registration_request_id" v-model="registration_request.id">
                <div class="flex-xs">
                    <div class="half-width-xs pr-3-xs">
                        <h3 class="txt-primary mb-6">
                            User Details
                        </h3>
                        <div class="form-group">
                            <strong>Email Address: </strong> {{ new_user.email }}
                            <input type="hidden" name="email" v-model="new_user.email">
                            <div class="txt-positive mt-2" v-if="registration_request.is_verified">
                                <i class="fal fa-check pr-2"></i><em>Verified at: {{ registration_request.formatted_email_verified_at }}</em>
                            </div>
                            <div class="txt-danger mt-2" v-else>
                                <i class="fal fa-times pr-2"></i><em>Email not verified</em>
                            </div>
                        </div>
                        <div class="form-group">
                            <strong>Company Type:</strong>
                            <span v-for="company_type in company_types" v-if="registration_request.company_type_id === company_type.id"> {{ company_type.label }} </span>
                        </div>
                        <div class="form-group">
                            <strong>Company Name:</strong> {{ registration_request.company_name }}
                            <input type="hidden" name="company_name" class="form-control" v-model="new_user.company_name">
                        </div>
                        <div class="form-group">
                            <strong>Name: </strong> {{ registration_request.name }}
                            <input type="hidden" name="name" v-model="new_user.name" class="form-control">
                        </div>
                        <div class="form-group">
                            <strong>Phone Number:</strong> {{ registration_request.phone }}
                            <input type="hidden" name="phone" v-model="new_user.phone" class="form-control">
                        </div>
                        <div class="form-group">
                          <label>Temporary Login</label>
                          <div class="radios _inline">
                            <label class="radio">
                              <input type="radio" v-model="new_user.temporary_login" name="temporary_login" :value="1">
                              <span class="radio-label">Yes</span>
                            </label>
                            <label class="radio">
                              <input type="radio" v-model="new_user.temporary_login" name="temporary_login" :value="0">
                              <span class="radio-label">No</span>
                            </label>
                          </div>
                        </div>
                        <div class="form-group" v-if="new_user.temporary_login">
                          <label>Temporary Login Expiration Date</label>
                          <datepicker input-class="form-control" v-model="new_user.temporary_login_expires_at" name="temporary_login_expires_at"></datepicker>
                        </div>
                    </div>
                    <div class="half-width-xs pl-3-xs">
                        <h3 class="txt-primary mb-6">
                            Address
                        </h3>
                        <div class="form-group">
                            <div class="mb-2">
                                {{ registration_request.address_line_1 }}
                                <input type="hidden" name="address_line_1" v-model="registration_request.address_line_1" class="form-control">
                            </div>
                            <div class="mb-2">
                                {{ registration_request.address_line_2 }}
                                <input type="hidden" name="address_line_2" v-model="registration_request.address_line_2" class="form-control">
                            </div>
                            <div class="mb-2">
                                {{ registration_request.address_town }}
                                <input type="hidden" name="address_town" v-model="registration_request.address_town" class="form-control">
                            </div>
                            <div class="mb-2">
                                {{ registration_request.address_county }}
                                <input type="hidden" name="address_county" v-model="registration_request.address_county" class="form-control">
                            </div>
                            <div class="mb-2">
                                {{ registration_request.address_postcode }}
                                <input type="hidden" name="address_postcode" v-model="registration_request.address_postcode" class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
              <div class="form-group">
                <strong v-if="registration_request.company_type_id === 1">
                  Which systems are you fabricating?
                </strong>
                <strong v-else>
                  Which systems are you using?
                </strong>
                <div v-for="system_type in epwin_system_types_for_registration_request" class="mb-2 mt-2">
                  <div>
                    {{ system_type.label }}
                  </div>
                  <div v-if="registration_request.company_type_id !== 1" class="mt-2">
                    <strong>From:</strong> {{ system_type.from_who }}
                  </div>
                </div>
                <div class="mb-6 mt-3" v-if="registration_request.company_type_id !== 1">
                  <strong>
                    Soffits, facias and trims from:
                  </strong>
                  <div class="mt-2">
                    {{ registration_request.soffits_facias_and_trims_from_who }}
                  </div>
                </div>
                <div class="mb-6 mt-3">
                  <strong>
                    Trade Counter:
                  </strong>
                  <div class="mt-2">
                    {{ registration_request.which_trade_counter }}
                  </div>
                </div>
              </div>
                <hr class="mb-6 mt-6">
                <div class="flex-xs mb-6">
                    <div>
                        <h3 class="txt-primary pr-3-xs">
                            Select which company this user belongs to:
                        </h3>
                    </div>
                  <div class="flex-2xs justify-end ml-a">
                    <div class="flex justify-end ml-a mb-1 mb-0-2xs">
                        <div class="pr-1">
                            <a class="btn-primary" @click.prevent="refreshCompanies()">
                                <i class="fal fa-sync"></i>
                            </a>
                        </div>
                        <div class="pr-3">
                            <a class="btn-primary" href="/company/create" target="_blank">
                                Add New
                            </a>
                        </div>
                    </div>
                    <div class="pr-1-2xs mb-1 mb-0-2xs">
                      <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open" style="min-width:165px;">
                        <div class="multi-select-input-placeholder">
                          Filter...
                          <div class="dropdown-icon">
                            <i class="fal fa-chevron-down"></i>
                          </div>
                        </div>
                        <div class="multi-select-input-inner" v-show="filter_dropdown_open">
                          <div class="multi-select-input-group">
                            <h1 class="input-group-title">System Types</h1>
                            <div class="checkboxes">
                              <div class="checkbox level-1" v-for="system_type in all_epwin_system_types">
                                <label>
                                  <input type="checkbox" name="selected_system_types" :value="system_type.id" v-model="selected_system_types">
                                  <span class="checkbox-label">{{ system_type.label }}</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <input type="text" placeholder="Search" class="form-control" v-model="companies_search_query">
                    </div>
                    </div>
                </div>
                <div class="form-group">
                  <div class="relative">
                    <div style="position: absolute; top:0; left:0; right: 0; bottom: 0; background:white; opacity: 0.8;" v-show="filtering"></div>
                        <table class="table _lined">
                            <tbody>
                            <tr v-for="(company, index) in companies">
                                <td style="width: 40px;">
                                    <input type="radio" name="company_id" v-model="new_user.company_id" :value="company.id" :id="`company_${company.id}`">
                                </td>
                                <td style="width: 125px;">
                                    <label :for="`company_${company.id}`">
                                        {{ company.account_code }}
                                    </label>
                                </td>
                                <td>
                                    <label :for="`company_${company.id}`">
                                        {{ company.name }}
                                    </label>
                                </td>
                                <td class="align-right" style="width: 40px;">
                                    <a :href='"/company/"+company.id' class="txt-primary pl-3" target="_blank">
                                        <i class="fa fa-eye"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                  </div>
                    <template>
                        <div class="pagination-bar wrapper mb-3 mt-3">
                            <div class="row">
                                <div class="col">
                                    <a @click.prevent="prevCompaniesPage()" v-if="current_companies_page > 1" class="btn-default _sm"><i
                                            class="fa fa-caret-left"></i></a>
                                    <a class="btn-default _sm">{{ current_companies_page }} / {{ total_companies_pages }}</a>
                                    <a @click.prevent="nextCompaniesPage()" v-if="current_companies_page < total_companies_pages"
                                       class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                                </div>
                                <div class="col align-right">
                                    <div class="mt-1 mb-1">
                                        {{ total_companies_count }} results found
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <hr class="mb-6 mt-6">
                <div class="flex justify-end mt-3">
                  <div class="pr-1">
                    <a class="btn-default txt-danger" :href="`/registration-request/deny/${registration_request.id}`">
                      Deny Request
                    </a>
                  </div>
                  <div>
                    <button type="submit" class="btn-primary" @click.stop.prevent="save()" :disabled="!registration_request.is_verified" :title="{'You will be able to approve this request when the user has verified their email address' : registration_request.email_verified_at === undefined}">
                      Create New User
                    </button>
                  </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import Datepicker from "vuejs-datepicker";

  export default {
    props: [
      'registration_request',
      'company_types',
      'all_epwin_system_types',
      'epwin_system_types_for_registration_request',
    ],
    components: {
      'datepicker': Datepicker,
    },
    data() {
      return {
        saving: false,
        csrfToken: document.querySelector('meta[name="csrf-token"]')
        .getAttribute('content'),
        new_user: {
          company_id: null,
          name: this.registration_request.name,
          phone: this.registration_request.phone,
          email: this.registration_request.email,
          company_name: this.registration_request.company_name,
          temporary_login: 0,
          temporary_login_expires_at: null,
          epwin_system_types: this.registration_request.epwin_system_types,
        },
        address: {
        },
        companies: [],
        current_companies_page: 1,
        companies_search_query: '',
        companies_limit: 5,
        total_companies_count: 0,
        total_companies_pages: 0,
        save_address: false,
        filter_dropdown_open: false,
        filtering: false,
        selected_system_types: [],
      };
    },
    mounted() {
      this.loadLinkableCompanies();
    },
    methods: {
      loadLinkableCompanies: _.debounce(function() {
        axios.post('/company/loadLinkableCompanies', {
          company_type_ids: [this.registration_request.company_type_id],
          page_number: this.current_companies_page,
          search_query: this.companies_search_query,
          selected_system_types: this.selected_system_types,
          limit: this.companies_limit,
        }).then((response) => {
          this.companies = response.data.data;
          this.total_companies_count = response.data.total;
          this.total_companies_pages = response.data.last_page;
          this.filtering = false;
        });
      }, 250),
      refreshCompanies() {
        this.companies_search_query = '';
        this.current_companies_page = 1;
        this.loadLinkableCompanies();
      },
      prevCompaniesPage() {
        this.current_companies_page = this.current_companies_page - 1;
        this.loadLinkableCompanies();
      },
      nextCompaniesPage() {
        this.current_companies_page = this.current_companies_page + 1;
        this.loadLinkableCompanies();
      },
      save() {
        this.saving = true;

        let validation_list = {
          company: this.new_user.company_id,
          name: this.new_user.name,
        };

        let validation_rules = {
          company: {
            presence: {
              allowEmpty: false,
              message: 'Please select which company this user belongs to.'
            },
          },
          name: {
            presence: {
              allowEmpty: false,
            },
          },
        };

        const validationErrors = Validate(validation_list, validation_rules);

        if (validationErrors) {
          Swal.fire({
            title: 'Unable to submit request',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          this.saving = false;
          return;
        }

        this.saving = true;
        document.getElementById('approve_new_user_form').submit();
      },
    },
    watch: {
      companies_search_query() {
        this.filtering = true;
        this.current_companies_page = 1;
        this.loadLinkableCompanies();
      },
      selected_system_types() {
        this.filtering = true;
        this.current_page = 1;
        this.loadLinkableCompanies();
      },
      'new_user.temporary_login'() {
        if(this.new_user.temporary_login_expires_at === null) {
          let date = new Date();
          date.setMonth(date.getMonth() + 1)
          this.new_user.temporary_login_expires_at = date;
        }
      },
    },
  };
</script>
